import { Component, OnInit, ViewChild } from '@angular/core';
import { ChartsModule } from 'ng2-charts';
import { ProcessService } from 'src/app/shared/process-service/process.service';
import { Process } from 'src/app/model/process-model/process.model';
import { Candidate } from 'src/app/model/candidate.model';
import { mergeMap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { IMMEventService } from 'src/app/shared/immEevent-service/imm-event.service';
import { IMMEvent } from 'src/app/model/imm-event/imm-event.model';
import { ApiService } from 'src/app/shared/api.service';
import { keyframes } from '@angular/animations';
import { NotificationService } from 'src/app/shared/notification.service';

// import { connectableObservableDescriptor } from 'rxjs/internal/observable/ConnectableObservable';
// import { stat } from 'fs';

@Component({
  selector: 'app-candidate-report',
  templateUrl: './candidate-report.component.html',
  styleUrls: ['./candidate-report.component.scss']
})

export class CandidateReportComponent implements OnInit {
  // eventId: any;
  private eventId = this.apiService.getEventId();
  eventName: string;
  startDate: string;
  endDate: string;
  eventDetails: IMMEvent;

  showDiv:boolean = false;
  visible:boolean = false;
  CurrentDate: string =  new Date().toISOString().slice(0,11);
  CurrentTime: string = new Date().toLocaleTimeString().slice(0,5);
  CurrentDateFinal = this.CurrentDate + this.CurrentTime;
  
  currentProcessName: string;
  currentProcessStatus: string;
  rowData = [];
  totalStudents = 0;
  private gridApi;
  private gridColumnApi;

  public allProcesses: Process[];
  private allCandidate: any;
  private shortListedMap = new Map();
  private arrayOfProcess = [];
  private totalRejected = [];
  private totalSelected = [];
  // private selectedCandidatesPercent = [];
  // private rejectedCandidatesPercent = [];
  // private processSelectedPercent= [];
  // private processRejectedPercent= [];
  private processSelected= [];
  private processRejected= [];
  private currentProcessId:number = 0;
  private candidateDetails: any[];
  private candidateDetailsToArray = [];
  private panelLength: number;
  private candidateLengthInEachPanel: number;
  private finalData = [];
  private panel = [];
  private panel_temp = [];
  
  private selectedCandidates = 0;
  private rejectedCandidates = 0;

  public barChartOptions1: any = {
    scaleShowVerticalLines: false,
    responsive: true,
  };
  
  public barchartOptions2: any = {
    scaleShowVerticalLines: false,
    responsive: true,
  };

  public mbarChartLabels1: string[] = this.arrayOfProcess;
  public mbarChartLabels2: string[] = [];

  public barChartType: string = 'bar';
  public barChartLegend: boolean = true;

  public barChartColors: Array<any> = [
    {
      backgroundColor: 'rgb(0,128,0)',
      borderColor: 'rgba(105,159,177,1)',
      pointBackgroundColor: 'rgba(105,159,177,1)',
      pointBorderColor: '#fafafa',
      pointHoverBackgroundColor: '#fafafa',
      pointHoverBorderColor: 'rgba(105,159,177)'
    },
    {
      backgroundColor: 'rgb(255,0,0)',
      borderColor: 'rgba(77,20,96,1)',
      pointBackgroundColor: 'rgba(77,20,96,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(77,20,96,1)'
    },
    {
    borderWidth: 2,
    }
  ];
  public barChartData1: any[] = [
    { data: this.totalSelected, label: 'Selection' },
    { data: this.totalRejected, label: 'Rejection' },
    // { data: this.totalOnhold, label: '% Onhold' },
    // { data: this.totalAbsent , label: '% Absent' },
    // { data: this.totalOnhold, label: '% Under Process' },
  ];

  public barChartData2: any[] = [
    { data: this.processSelected, label: 'Selection' },
    { data: this.processRejected, label: 'Rejection' },
    // { data: this.totalOnhold, label: '% Onhold' },
    // { data: this.totalAbsent , label: '% Absent' },
    // { data: this.totalOnhold, label: '% Under Process' },
  ];
  columnDefs = [
    {
      headerName: 'Candidate ID',
      field: 'candidateId',
      maxWidth: 110,
      checkboxSelection: true, 
      headerCheckboxSelection: true,
      cellStyle: {
        overflow: 'hidden !important',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },
      suppressSizeToFit: true,
    },
    {
      headerName: 'Candidate Name',
      field: 'candidateName',
      maxWidth: 130,
      cellStyle: {
        overflow: 'hidden !important',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },
      suppressSizeToFit: true,
    },
    {
      headerName: 'Email',
      field: 'email',
      maxWidth: 120,
      cellStyle: {
        overflow: 'hidden !important',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },
      suppressSizeToFit: true,
    },
    {
      headerName: 'Contact No.',
      field: 'contactNo',
      maxWidth: 110,
      cellStyle: {
        overflow: 'hidden !important',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },
      suppressSizeToFit: true,
    },
    {
      headerName: 'Attendance',
      field: 'attendance',
      maxWidth: 120,
      cellStyle: {
        overflow: 'hidden !important',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },
      suppressSizeToFit: true,
    },
    {
      headerName: 'Status',
      field: 'status',
      maxWidth: 90,
      cellStyle: {
        overflow: 'hidden !important',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },
      suppressSizeToFit: true, 
    },
    {
      headerName: 'Feedback',
      field: 'feedback',
      maxWidth: 110,
      cellStyle: {
        overflow: 'hidden !important',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },
      suppressSizeToFit: true, 
    },
    {
      headerName: 'Panel Members',
      field: 'panelMembers',
      maxWidth: 180,
      cellStyle: {
        overflow: 'hidden !important',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },
      suppressSizeToFit: true,
    },
  ];

  public currentProcess(text: string, status: string, seq: number, processId: number): void{
    if( this.allProcesses[this.allProcesses.length-1].processName == this.currentProcessName){
      this.visible = true;
    }
    else{
      this.visible = false;
    }
    this.currentProcessStatus = status;
    this.currentProcessName = text.trim();
    
    if(status != 'Upcoming'){
      this.showDiv = true;
    } else {
      this.showDiv = false;
      this.notificationService.warn("This process has not started yet");
    }
    this.mbarChartLabels2[0]= text;
    this.processSelected[0] = this.totalSelected[seq-1];
    this.processRejected[0] = this.totalRejected[seq-1];
    this.scrollToBottom();

    // Setting up scales for dynamic data of current process
    let processMax = Math.max(this.processSelected[0],this.processRejected[0]);
    let processIdealStep =  Math.round((20*processMax)/100);
    let processMaximumScale = (120*processMax)/100;
    if(processIdealStep == 0){
      processIdealStep = 1;
    }
    if((processMaximumScale-processMax)>=1){
      processMaximumScale = Math.round((120*processMax)/100);
    }else{
      processMaximumScale = Math.round((120*processMax)/100)+1;
    }
    console.log(processIdealStep);
    this.currentProcessId = processId;
    this.getCandidateDataForEachProcess();
    
    this.barchartOptions2 = {
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              max: processMaximumScale,
              stepSize: processIdealStep,
            }
          }
        ],
        xAxes: [{
          barPercentage: 0.3
      }]
      }
    };
  }

  // events
  public chartClicked(e: any): void {
    console.log(e);
  }

  public chartHovered(e: any): void {
    console.log(e);
  }
  constructor(
    private apiService: ApiService,
    private eventService: IMMEventService,
    private processService: ProcessService,
    private notificationService: NotificationService,
  ) { }

  ngOnInit() {
    this.getEvent();
    this.getAllProcess();
  }

  getEvent() {
    this.eventService.findById(this.eventId).then(
      eventDetail => {
        this.eventDetails = eventDetail;
        this.eventName = this.eventDetails.eventName;
        this.startDate = this.eventDetails.startDate.slice(0,17);
        this.endDate = this.eventDetails.endDate.slice(0,17);

        // this.arrayOfProcess.push('Shortlisted');
        // this.allProcesses = this.eventDetails.processes;
        // if (this.allProcesses != null) {
        //   for (let i = 0; i < this.allProcesses.length; i++) {
        //     this.allProcesses[i].panel
        //     this.selectedCandidates = 0;
        //     this.rejectedCandidates = 0;
        //     this.arrayOfProcess.push(processes[i].processName);
        //     await this.getShortlistedCandidates(processes[i].processId, processes[i].processSeq);
        //     console.log(this.totalSelected + "-----------" + this.totalRejected);
        //   }
        // }
      }
    );
  }

  async getCandidateDataForEachProcess() {
    this.processService.findById(this.currentProcessId).then(
      data => {
        this.candidateDetails = data;
        this.candidateDetailsToArray = Object.values(this.candidateDetails);
        this.candidateDetailsToArray = Object.values(this.candidateDetailsToArray[9]);
        this.panelLength = this.candidateDetailsToArray.length;
        this.finalData = [];
        let j = 0;
        for(let i = 0;i< this.panelLength ; i++){
          this.panel = Object.values(this.candidateDetailsToArray[i]);
          this.panel_temp = Object.values(this.panel[8]);
          this.candidateLengthInEachPanel = this.panel_temp.length;

          let panelMemberLength = Object.values(this.panel[9]).length;
          let res = '';
          for(let k = 0;k < panelMemberLength; k++){
            let panelMemberData = this.panel[9][k];
            let panelMemberName = panelMemberData.panelMemberName;
            if(k != panelMemberLength-1)
              res += panelMemberName+ ' , ';
            else
              res += panelMemberName;
          }

          for(j = 0; j< this.candidateLengthInEachPanel; j++){
            delete this.panel_temp[j].completeFeedback;
            delete this.panel_temp[j].processName;
            delete this.panel_temp[j].panelId;
            if(this.panel_temp[j].attendance == 1){
              this.panel_temp[j].attendance = "Present";
            }
            else {
              this.panel_temp[j].attendance = "Absent";
            }

            if(this.panel_temp[j].status == 2){
              this.panel_temp[j].status = "Selected";
            }
            else if(this.panel_temp[j].status == 3){
              this.panel_temp[j].status = "Rejected";
            }
            else{
              this.panel_temp[j].status = "Not Appeared";
            }

            if(this.panel_temp[j].feedback == null){
              this.panel_temp[j].feedback = "NA";
            }
            this.panel_temp[j].panelMembers = res;
            let temp = this.panel_temp[j];
            this.finalData.push(temp);
          } 
        }
        this.rowData = this.finalData;
        this.totalStudents = this.rowData.length;
      },
      err => {
        console.log(err);
      }
    );
  }

  async getAllProcess() {
    // this.arrayOfProcess.push('Shortlisted');
    this.processService.findAll().then(
      async processes => {
        this.allProcesses = processes;
        if (processes != null) {
          for (let i = 0; i < processes.length; i++) {
            this.selectedCandidates = 0;
            this.rejectedCandidates = 0;
            this.arrayOfProcess.push(processes[i].processName);
            await this.getShortlistedCandidates(processes[i].processId, processes[i].processSeq);
            console.log(this.totalSelected + "-----------" + this.totalRejected);
          }
        }
      },
      err => {
        console.log(err);
      }
    );
  }
  async getShortlistedCandidates(processId, processSeq) {
    await this.processService.findAllShortlistedCandidates(processId).then(
      candidates => {
        // if (processSeq === 1) {
        //   this.totalSelected.push(candidates.length);
        //   this.totalRejected.push(0);
        //   //return;
        // }
        for (let i = 0; i < candidates.length; i++) {
          this.totalSelectedRejected(candidates[i].panelCandidates);
        }
        this.totalRejected.push(this.rejectedCandidates);
        this.totalSelected.push(this.selectedCandidates);

        let maxSelected = Math.max(...this.totalSelected); 
        let maxRejected = Math.max(...this.totalSelected); 
        let maximumScale = Math.max(maxSelected,maxRejected);
        let idealStep =  Math.round((20*maximumScale)/100);
        let maxScale = (120*maximumScale)/100;

        if(idealStep == 0){
          idealStep = 1;
        }
        if((maxScale-maximumScale)>=1){
          maxScale = Math.round((120*maximumScale)/100);
        }else{
          maxScale = Math.round((120*maximumScale)/100)+1;
        }

        this.barChartOptions1 = {
          scaleShowVerticalLines: false,
          responsive: true,
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  max: maxScale,
                  stepSize: idealStep,
                }
              }
            ],
            xAxes: [{
              barPercentage: 0.5
          }]
          }
        };

        // this.selectedCandidatesPercent.push(Math.round(this.selectedCandidates / (this.selectedCandidates + this.rejectedCandidates)*100));
        // this.rejectedCandidatesPercent.push(Math.round(this.rejectedCandidates / (this.selectedCandidates + this.rejectedCandidates)*100));

      },
      err => {
        console.log(err);
      }
    );
  }
  totalSelectedRejected(allPanelCandidate: Candidate[]) {
    for (let i = 0; i < allPanelCandidate.length; i++) {
      if (allPanelCandidate[i].status == 2) {
        this.selectedCandidates = this.selectedCandidates + 1;
      } else if (allPanelCandidate[i].status == 3) {
        this.rejectedCandidates = this.rejectedCandidates + 1;
      }
    }
  }

  scrollToBottom(): void {
      try {
        document.getElementById('bottom').scrollIntoView({behavior:"auto", block: 'center' });
      } 
      catch(err) { }                 
  }

  studentDataToCSV(data): boolean{
    try {
      if (!Array.isArray(data) || data === null || data.length==0) {
        return null;
      }
      var finalData = 'S.No.\t'+'Candidate Id\t'+'Candidate Name\t'+'Email\t'+'Contact No\t'+'Attendance\t'+'Status\t'+'Feedback\t'+'Panel Mmebers\t'+'\n';
      for (var j = 0; j < data.length; j++) {
          var temp = Object.values(data[j]);
          finalData += (j+1)+"\t";
          finalData += temp+"\n";
      }
      
      let csv = finalData;
      const fileName = "CandidatesData";
    
      const uri = `data:application/csv;charset=utf-8,${escape(csv)}`;
      const link = document.createElement('a');
      link.href = uri;
      // link.style = 'visibility:hidden';
      link.download = `${fileName}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      return true;
    } catch (ex) {
      return null;
    }
  };
  
  downloadStudentData() : void {
    const selectedData = this.getSelectedRowData();
        const data = this.studentDataToCSV(selectedData);
    
    //   const data = this.studentDataToCSV(this.rowData);
    if(data == null){
        this.notificationService.warn("No data selected to download");
    }
  
    console.log(">>>>>>>>>", selectedData);
  }

  getSelectedRowData() {
    let selectedNodes = this.gridApi.getSelectedNodes();
    let selectedData = selectedNodes.map(node => node.data);
    return selectedData;
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

  }
}
